var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTgIcon = function SvgTgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.248522 6.33899C1.93187 5.41175 3.81095 4.63787 5.56667 3.86003C8.58719 2.58599 11.6197 1.33403 14.6828 0.168471C15.2788 -0.0301292 16.3496 -0.224349 16.4546 0.658851C16.3972 1.90901 16.1606 3.15185 15.9984 4.39469C15.5866 7.12781 15.1107 9.85157 14.6466 12.5757C14.4867 13.4831 13.35 13.9528 12.6227 13.3721C10.8748 12.1915 9.11339 11.0223 7.38779 9.81425C6.82253 9.23987 7.34669 8.41505 7.85153 8.00489C9.29117 6.58613 10.8179 5.38073 12.1823 3.88865C12.5504 2.99987 11.4629 3.74891 11.1043 3.97841C9.13337 5.33657 7.21073 6.77765 5.13281 7.97129C4.07141 8.55557 2.83433 8.05625 1.77341 7.73021C0.822158 7.33637 -0.571774 6.93959 0.248426 6.33905L0.248522 6.33899Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
};
export default SvgTgIcon;